export * from './registroPropiedadSlice';
export * from './thunks';